import { createContext } from "react";

const ScreenLinkContext = new createContext();

export default ScreenLinkContext;
